export default "__VITE_ASSET__DkDXGG9C__"